import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { ArtikelGroupFilterSettings } from './artikelgroupfiltersettings.entity';
//#endregion

export const ArtikelGroupFilterSettingsConfig = {
  name: "ArtikelGroupFilterSettings",
  annotations: [],
  fields: {
    groupId: {type: 'Edm.Int32'},
    filterMarken: {type: 'Edm.String'},
    filterHersteller: {type: 'Edm.String'},
    filterArtikel: {type: 'Edm.String'},
    filterArtikelRemoved: {type: 'Edm.String'},
    filterProduktTypen: {type: 'Edm.String'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    artikelliste: {type: 'entities.articles.ArtikelGroup', collection: true, navigation: true},
    group: {type: 'entities.schema.Group', navigation: true, field: 'groupId', ref: 'id'},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<ArtikelGroupFilterSettings>;